import type { ReactNode } from 'react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteAnalytics = ({
  pageName,
  properties,
  children,
}: {
  pageName?: string;
  properties?: Record<string, unknown>;
  children: ReactNode;
}) => {
  const location = useLocation();

  useEffect(() => {
    const currentPageName =
      pageName ||
      location.pathname.replace(/^\//, '').replace(/\//g, '-') ||
      'Home';

    window.analytics?.page?.(currentPageName, {
      properties,
    });
  }, [location, pageName, properties]);

  return <>{children}</>;
};

export default RouteAnalytics;
